// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import {RoomOutfitEditorForm} from '@app/features/cosmetics/components/RoomOutfitEditorForm';
import * as RouterUtils from '@app/features/navigation/utils/RouterUtils';
import {isShopPageAvailable} from '@app/features/shop/utils/ShopAvailability';
import {SHOP_ROOM_PATH} from '@app/features/shop/utils/ShopSets';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import styles from '@app/features/voice_scene/components/RoomOutfitModal.module.css';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {StorefrontIcon} from '@phosphor-icons/react';

const TITLE_DESCRIPTOR = msg({
	message: 'Room outfit',
	comment: 'Title of the outfit editor opened from a voice call 3D room.',
});

const SHOP_NOTE_DESCRIPTOR = msg({
	message: 'More outfits and characters in the Shop',
	comment: 'Footer note of the outfit editor opened from a voice call 3D room, next to a button that opens the shop.',
});

const GO_TO_SHOP_DESCRIPTOR = msg({
	message: 'Go to Shop',
	comment:
		'Button in the footer of the outfit editor opened from a voice call 3D room; closes it and opens the shop on its room characters. The call stays on.',
});

// Leaving the room page for the shop keeps the call; the dialog closes on the way.
function openRoomShop(): void {
	ModalCommands.pop();
	RouterUtils.transitionTo(SHOP_ROOM_PATH);
}

export function RoomOutfitModal() {
	const {i18n} = useLingui();
	return (
		<Modal.Root size="large" data-flx="voice-scene.room-outfit-modal.root">
			<Modal.Header title={i18n._(TITLE_DESCRIPTOR)} data-flx="voice-scene.room-outfit-modal.header" />
			<Modal.Content data-flx="voice-scene.room-outfit-modal.content">
				<RoomOutfitEditorForm data-flx="voice-scene.room-outfit-modal.editor" />
			</Modal.Content>
			{isShopPageAvailable() && (
				<Modal.Footer className={styles.footer} data-flx="voice-scene.room-outfit-modal.footer">
					<p className={styles.shopNote} data-flx="voice-scene.room-outfit-modal.shop-note">
						{i18n._(SHOP_NOTE_DESCRIPTOR)}
					</p>
					<Button
						variant="secondary"
						small={true}
						leftIcon={<StorefrontIcon weight="bold" data-flx="voice-scene.room-outfit-modal.shop-icon" />}
						onClick={openRoomShop}
						data-flx="voice-scene.room-outfit-modal.button.open-shop"
					>
						{i18n._(GO_TO_SHOP_DESCRIPTOR)}
					</Button>
				</Modal.Footer>
			)}
		</Modal.Root>
	);
}
